import { MouseEvent, useEffect, useState } from "react";
import { useCookies } from "react-cookie";
import { Link, useNavigate } from "react-router-dom";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import LoaderOverlay from "../loading_page/loading_page";
import axios from "axios";
import _ from "lodash";
import "./qna_page.css";

type Post = {
  _id: string;
  title: string;
  writer: string;
  view: number;
  createdAt: string;
};

function QnaPage() {
  const [cookie, setCookie] = useCookies(["admin"]);
  const [posts, setPosts] = useState<Post[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [currentPageNum, setCurrentPageNum] = useState<number>(1);
  const [totalPageNum, setTotalPageNum] = useState<number>(0);
  const navigate = useNavigate();
  const limit = 10;

  const empty = (
    <tr className="empty_board">
      <td colSpan={5}>등록된 게시글이 없습니다</td>
    </tr>
  );

  const writeBtn = (
    <div className="write_btn_container">
      <button className="write_btn">
        <Link to="./write">작성</Link>
      </button>
    </div>
  );

  const onPageBtnClicked = (
    event: React.ChangeEvent<unknown>,
    value: number
  ) => {
    setCurrentPageNum(value);
  };

  const onDetailClicked = (
    event: MouseEvent<HTMLTableRowElement>,
    postId: string
  ) => {
    navigate("/community/qna/detail/" + postId);
  };

  useEffect(() => {
    const getPostsAPI = process.env.REACT_APP_SERVER_URI + "/post/list";

    setIsLoading(true);

    axios
      .get(getPostsAPI, {
        params: {
          postType: "qna",
          limit,
          pageNum: currentPageNum,
        },
        headers: {
          "Content-Type": "application/json",
        },
      })
      .then((res) => {
        if (!res.data.result) {
          return alert(res.data.message);
        }
        setPosts(res.data.foundPosts);
        const totalCount = res.data.totalCount;
        const totalPage = Math.ceil(totalCount / limit);
        setTotalPageNum(totalPage);
      })
      .catch((error) => {
        alert(error);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, [currentPageNum]);

  return (
    <div className="qna_page">
      <div className="qna_container">
        <table className="table" id="notice">
          <thead>
            <tr>
              <th>번호</th>
              <th className="title">제목</th>
              <th>작성자</th>
              <th>날짜</th>
              <th>조회</th>
            </tr>
          </thead>
          <tbody>
            {_.isEmpty(posts)
              ? empty
              : posts.map((post, idx) => (
                  <tr
                    className="post_item"
                    onClick={(event) => {
                      onDetailClicked(event, post._id);
                    }}
                  >
                    <td>{limit * (currentPageNum - 1) + idx + 1}</td>
                    <td className="title">{post.title}</td>
                    <td>{post.writer}</td>
                    <td>{new Date(post.createdAt).toLocaleDateString()}</td>
                    <td>{post.view}</td>
                  </tr>
                ))}
          </tbody>
        </table>
        <div className="page_btn_container">
          <Stack spacing={2}>
            <Pagination
              count={totalPageNum}
              page={currentPageNum}
              onChange={onPageBtnClicked}
              variant="outlined"
              shape="rounded"
            />
          </Stack>
        </div>
      </div>
      {_.isEmpty(cookie) ? <></> : writeBtn}
      <LoaderOverlay open={isLoading} text="데이터를 불러오는 중입니다" />
    </div>
  );
}

export default QnaPage;
